import { useExportDocumentsController } from '@dealstack/frontend/app/pages/Export/ExportDocuments/useExportDocumentsController.tsx';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationExports } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex, Text } from '@mantine/core';
import { memo, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GetTaskRes } from '@dealstack/shared/lib/generated';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable.tsx';

const ExportDocumentsComponent = () => {
	const tExports = useTranslationExports();
	const { data, isLoading, columns, mantineTableDataOperations, rowCount } =
		useExportDocumentsController();

	const navigate = useNavigate();
	const location = useLocation();

	const hasBackHistory = location.key !== 'default';

	const onBackClick = useCallback(
		(e: React.MouseEvent) => {
			if (hasBackHistory) {
				e.preventDefault();

				navigate(-1);
			}
		},
		[hasBackHistory]
	);

	return (
		<div>
			<Text size="B4Bold" mb="1rem">
				{tExports('header')}
			</Text>
			<Link to={ROUTES.DASHBOARD} onClick={onBackClick}>
				<Flex gap="0.5rem" align="center" mb="2rem" c="blue.6">
					<Icon variant="arrow-left" size="lg" />
					<Text size="B6Bold">
						{hasBackHistory ? tExports('back') : tExports('back_to_dashboard')}
					</Text>
				</Flex>
			</Link>
			<MantineTable<GetTaskRes>
				data={data}
				columns={columns}
				isLoading={isLoading}
				dataOperations={mantineTableDataOperations}
				enablePagination
				manualPagination
				manualSorting
				rowCount={rowCount}
				enableTopToolbar={false}
				mantineTableBodyRowProps={({ row }) => ({
					id: row.id,
					style: {
						height: 'unset',
					},
				})}
			/>
		</div>
	);
};

export const ExportDocuments = memo(ExportDocumentsComponent);
